import { NBSP } from 'shared/constants/text';
import type { IPhone } from 'shared/types/phone';

const joinPhone = ({ countryCode, number }: IPhone): string => `${countryCode}${number}`;

/**
 * Телефон: `+7 495 123-45-67`. Алгоритм `utils/format_phone.ts` монолита по склеенному номеру: последние 10 цифр
 * группами, перед ними код страны (ровно 10 цифр — `+7`); меньше 10 цифр — как есть
 */
export function formatPhone(phone: IPhone): string {
  const raw = joinPhone(phone);
  const digits = raw.replace(/\D/g, '');

  if (digits.length < 10) {
    return raw;
  }

  const country = digits.length === 10 ? '7' : digits.slice(0, -10);
  const local = digits.slice(-10);

  return `+${country}${NBSP}${local.slice(0, 3)}${NBSP}${local.slice(3, 6)}-${local.slice(6, 8)}-${local.slice(8)}`;
}

/** Ссылка `tel:` из исходного номера */
export const getPhoneLink = (phone: IPhone): string => `tel:${joinPhone(phone).replace(/[^\d+]/g, '')}`;
